// Session-scoped draft persistence for in-progress "Add Property" forms.
//
// Keeps a copy of what the user has typed in sessionStorage so the data
// survives a reload, a navigation, an accidental dismissal, or any unexpected
// unmount within the same browser tab. Drafts are cleared on a successful
// submit or an explicit "discard". Keys are namespaced per community so a
// draft in one tenant can't surface in another within the same tab.

const communityKey = () =>
  localStorage.getItem("communityId") ||
  process.env.REACT_APP_COMMUNITY_ID ||
  "1";

const draftKey = (name) => `yarcobr:draft:${communityKey()}:${name}`;

export function loadDraft(name) {
  try {
    const raw = sessionStorage.getItem(draftKey(name));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveDraft(name, data) {
  try {
    sessionStorage.setItem(draftKey(name), JSON.stringify(data));
  } catch {
    /* ignore quota / serialization errors */
  }
}

export function clearDraft(name) {
  try {
    sessionStorage.removeItem(draftKey(name));
  } catch {
    /* ignore */
  }
}
